module.exports = __webpack_public_path__ + "media/dashboard/components/Accordion/icons/participantes-27d2dd7d70740e99c1842b7b7307a05a.svg";